import { Http } from '../../../support';
import GetNewListHighlighted from '../../../support/GetNewListHighlighted';

export const initialState = {
  selectedTab: 'todo',
  result: undefined,
  error: undefined,
  busy: false,
  data: [],
  filters: {
    page: 1,
    search: '',
  },
  pagination: {
    limit: 25,
  },
};

const highlight = (store, item) => {
  const fullList = store.state.admin.clientes.list.data;

  const newList = GetNewListHighlighted.make(fullList, item, true);

  store.setState((state) => {
    state.admin.clientes.list.data = newList;
  });

  setTimeout(() => {
    const newList = GetNewListHighlighted.make(fullList, item, false);

    store.setState((state) => {
      state.admin.clientes.list.data = newList;
    });
  }, 5000);
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.admin.clientes.list = {
      ...state.admin.clientes.list,
      ...data,
    };
  });
};

const paginate = async (store, meta) => {
  store.setState((state) => {
    state.admin.clientes.list = {
      ...state.admin.clientes.list,
      busy: true,
      filters: {
        ...state.admin.clientes.list.filters,
        ...meta,
      },
      pagination: {
        ...state.admin.clientes.list.pagination,
        limit: meta?.limit ?? 25,
      },
    };
  });

  const { pagination, filters } = store.state.admin.clientes.list;

  try {
    const params = {
      ...filters,
      ...meta,
      limit: pagination.limit,
      include: 'config,servicios,metadata',
    };

    const response = await Http.get('/api/clientes', { params });

    store.setState((state) => {
      state.admin.clientes.list = {
        ...state.admin.clientes.list,
        busy: false,
        data: response.data,
        pagination: {
          ...state.admin.clientes.list.pagination,
          ...response.meta.pagination,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.admin.clientes.list.busy = false;
      state.admin.clientes.list.error = error.data || error;
    });
  }
};

const ClienteListStore = {
  state: () => initialState,
  actions: {
    paginate,
    highlight,
    setPartialState,
  },
};

export default ClienteListStore;
